import * as Ariakit from '@ariakit/react';
import styled, { css } from 'styled-components';
import { easeInOutCubic, fromMd, timingSlower, zIndexModal } from '../../../constants';
const drawerPositionCss = css(o => {
    const shared = {
        transition: `${timingSlower} ${easeInOutCubic} all`,
    };
    if (o.$dir === 'ltr') {
        return {
            'left': 0,
            'top': 0,
            'transform': 'translateX(-100%)',
            '&[data-enter]': {
                transform: 'translateX(0)',
            },
            ...shared,
        };
    }
    if (o.$dir === 'rtl') {
        return {
            'right': 0,
            'top': 0,
            'transform': 'translateX(100%)',
            '&[data-enter]': {
                transform: 'translateX(0)',
            },
            ...shared,
        };
    }
    if (o.$dir === 'btt') {
        return {
            'bottom': 0,
            'left': 0,
            'right': 0,
            'transform': 'translateY(100%)',
            '&[data-enter]': {
                transform: 'translateY(0)',
            },
            ...shared,
        };
    }
    return {
        right: 0,
        transform: 'translateX(100%)',
        ...shared,
    };
});
export const Drawer = styled(Ariakit.Dialog) `
  ${drawerPositionCss};
  background-color: ${o => o.theme.color.fill.background};
  position: fixed;
  z-index: ${zIndexModal};
  overflow-y: auto;
  width: 100svw;

  ${o => o.$dir === 'btt'
    ? `max-height: 90svh;`
    : `height: 100svh;
        ${fromMd} {
          max-width: 50svw;
          width: auto;
        }`}
`;
//# sourceMappingURL=styles.js.map